/*
  color: 38808E, 90BFB1, CDA39E, 8FA9A8, F4BA9C, F8DEC1 - http://i0.wp.com/s-media-cache-ak0.pinimg.com/736x/e5/f7/b1/e5f7b12acc6e2c68ad861d1bc6b0325c--color-palette-teal-peach-color-scheme.jpg
  367D94, A9BBBC, 775A7D, 4A4173, 071125,
  D4B351 yellow-text, 70BAA1, 48929D, 344B74, 2E3355, 090E26 (dark) https://i.pinimg.com/736x/90/3e/6d/903e6d8360185a4460d92b2ebe26ca87--aqua-blue-bedrooms-blue-bedroom-colors.jpg
*/
export const SiteInfo = {
  lastUpdate: "12/03/2017",
  links: [
    {
      name: "github",
      val: "https://github.com/mwei2509",
      icon: "github-square",
    },
    {
      name: "linkedin",
      val: "https://linkedin.com/in/melissa-wei/",
      icon: "linkedin-square",
    },
    {
      name: "resume",
      val: "https://drive.google.com/file/d/1PCYIMl5hjqmXzXiLhgf9k83AX5vuMHLd/view?usp=sharing",
      icon: "file-pdf-o",
    },
  ],
  photos: [
    {
      bgColor: "#A9BBBC",
      url: "https://i.imgur.com/PnvUnWj.jpg",
    },
    { bgColor: "#367D94", url: "https://i.imgur.com/97HSMgr.jpg" },
    { bgColor: "#70BAA1", url: "https://i.imgur.com/oTQHd1X.jpg" },
  ],
  mainPhoto: "",
  about: `I'm a Brooklyn-based software engineer (full stack and platform) with a passion for building
    web application and dev tools (browser extensions, CLI tools, etc).  I work primarily in
    JavaScript/TypeScript (NodeJS, React/Redux) and have a keen interest in doing more Go projects.\n\n
   When I'm not coding, you can find me in the mountains either rock climbing or hiking, or hanging out
   with my cats (Evie and Bilbo!). I'm constantly looking for ways to incorporate tech to contribute
   to the things I'm passionate about.`,
};



// WEBPACK FOOTER //
// ./src/content/info.js